














import { Component, Vue } from "vue-property-decorator"

@Component
export default class Default extends Vue {
  logout(): void {
    this.$store.dispatch("logout").then(() => {
      this.$router.push("/")
    })
  }
}
